import VirtualList from '@anm/components/list/VirtualList';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const VirtualListWrapperAdaptiveStyles = media.tablet`
  margin: 0;
  width: 100%;
  > div {
    flex-basis: auto;
    max-width: 100%;
    margin-right: 17px;
    width: ${isMobileOrIPad() ? 'calc((100% - 34px)/3)' : '280px'};
    > div {
        margin-bottom: 20px;
    }
  }
`;

const VirtualListWrapperMobileStyles = media.phone`
  > div {
    width: ${isMobileOrIPad() ? 'calc((100% - 17px)/2)' : '280px'};
  }
`;

const VirtualListWrapper = styled(VirtualList)`
  width: auto;
  display: inline-flex;
  &:first-of-type {
    display: flex;
    margin-top: 18px;
    justify-content: flex-start;
  }
  > div {
    margin-right: 40px;
    flex-shrink: 0;
    width: 280px;
    &:last-child {
      margin-right: 0;
    }
    > div {
      margin-bottom: 40px;
    }
  }
  ${VirtualListWrapperAdaptiveStyles};
  ${VirtualListWrapperMobileStyles};
`;

export default VirtualListWrapper;
